import { render } from "./TopNav.vue?vue&type=template&id=d2a7319c"
import script from "./TopNav.vue?vue&type=script&lang=ts"
export * from "./TopNav.vue?vue&type=script&lang=ts"
script.render = render

export default script